module.exports = __webpack_public_path__ + "img/message.88e2c989.png";